var _path, _circle, _circle2, _circle3, _circle4, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFlag(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 72 72",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#d22f27",
    d: "M5 17h62v38H5z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 34,
    r: 1.75,
    fill: "#f1b31c"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 1.75,
    fill: "#f1b31c"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 28,
    cy: 31,
    r: 1.75,
    fill: "#f1b31c"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 28,
    cy: 26,
    r: 1.75,
    fill: "#f1b31c"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#f1b31c",
    stroke: "#f1b31c",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m13.528 32.445 2.472-8 2.473 8L12 27.5h8z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M5 17h62v38H5z"
  })), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    x: 33.79,
    y: 45.839,
    style: {
      fontStyle: "normal",
      fontWeight: 400,
      fontSize: "29.06674194px",
      lineHeight: "125%",
      fontFamily: "sans-serif",
      letterSpacing: 0,
      wordSpacing: 0,
      fill: "#000",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: ".7266686px",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 33.79,
    y: 45.839,
    style: {
      strokeWidth: ".7266686px"
    }
  }, "\u7B80")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlag);
export default __webpack_public_path__ + "static/media/flag.3fe6473ced48bc59abc8c1668bb53c01.svg";
export { ForwardRef as ReactComponent };